import React from 'react';
import { Row, Col, Typography, Card } from 'antd';
import DoughnutChartCard from '../DoughnutChartCard';

const { Title } = Typography;

interface OverviewSectionProps {
  sectionTitle: 'Encaissement' | 'Salaire';
  fraisData: {
    title: string;
    amount: number;
    name: string;
    className: string;
  }[];
  pieChartDataOMWave: { name: string; value: number }[];
  pieChartDataEcoles: { name: string; value: number }[];
  pieColorsOMWave: string[];
  pieColorsEcoles: string[];
}

const OverviewSection: React.FC<OverviewSectionProps> = ({
  sectionTitle,
  pieChartDataOMWave,
  pieChartDataEcoles,
  pieColorsOMWave,
  pieColorsEcoles,
}) => {
  return (
    <Card style={{ background: '#fafafa' }}>
      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col span={24}>
          <Title level={4}>{sectionTitle}</Title>
        </Col>
        <DoughnutChartCard title="OM/Wave" data={pieChartDataOMWave} colors={pieColorsOMWave} />
        <DoughnutChartCard title="Ecoles" data={pieChartDataEcoles} colors={pieColorsEcoles} />
      </Row>
    </Card>
  );
};

export default OverviewSection;
